import styled from "styled-components";
import { Row } from "../../../../components/flex/styled";

export const AddNewEmployeeWrapper = styled("div")(() => {
  return {
    backgroundColor: "var(--background-color)",
    borderRadius: "1rem",
    "& h2": {
      marginBlock: 0,
      fontSize: "24px",
    },
    "& p": {
      fontSize: "18px",
    },
    "& .employeeForm": {
      overflow: "hidden",
      padding: "var(--cardPadding)",
      "& form": {
        display: "flex",
        flexDirection: "column",
        gap: "calc(var(--flexGap) * 1.5)",
        overflow: "hidden",
      },
    },
    "& .employeeForm input, & .employeeForm select": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) /2)",
      outline: "none",
      backgroundColor: "var(--color-button-secondary)",
      border: "1px solid var(--color-primary-hover)",
      borderRadius: ".5rem",
      fontWeight: "400",
      "&:disabled": {
        cursor: "not-allowed",
        opacity: 0.6,
      },
    },
    "& .employeeForm label": {
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "var(--color-text)",
    },
    "& .employeeForm fieldset": {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      gap: "calc(var(--flexGap)/8)",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& .employeeForm textarea": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "-webkit-fill-available",
      fontWeight: "400",
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) /2)",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: ".5rem",
    },
    "& .add-new-employee-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--background-color)",
      padding: "var(--cardPadding)",
      borderRadius: "1rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
    },
    "& .switch-column": {
      gap: "calc(var(--flexGap)/3)",
      "& .switch": {
        position: "relative",
        display: "inline-block",
        width: "60px",
        height: "34px",
      },
      "& .pension-check": {
        opacity: 0,
        width: 0,
        height: 0,
      },
      "& .slider": {
        position: "absolute",
        cursor: "pointer",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#CCCCCC",
        transition: ".4s",
      },
      "& .slider::before": {
        position: "absolute",
        content: '""',
        height: "26px",
        width: "26px",
        left: "4px",
        bottom: "4px",
        backgroundColor: "white",
        transition: ".4s",
      },
      "& .pension-check:checked + .slider": {
        backgroundColor: "var(--color-primary)",
      },
      "& .pension-check:focus + .slider": {
        boxShadow: "0 0 1px var(--color-primary)",
      },
      "& .pension-check:checked + .slider:before": {
        transform: "translateX(26px)",
      },
      "& .slider.round": {
        borderRadius: "34px",
      },
      "& .slider.round::before": {
        borderRadius: "50%",
      },
    },
    "& .edit-employee-success-modal": {
      width: "min(520px, calc(100% - 32px)) !important",
    },
    "& .edit-employee-success-modal > div": {
      width: "100%",
      margin: 0,
      backgroundColor: "var(--color-background) !important",
      padding: "var(--cardPadding) !important",
      borderRadius: "24px !important",
      boxShadow: "0 24px 60px rgba(41, 49, 112, 0.2) !important",
      border: "1px solid rgba(78, 87, 187, 0.12) !important",
      overflow: "hidden !important",
    },
    "& .edit-employee-success-modal .icon-box": {
      display: "flex",
      justifyContent: "center",
      marginBottom: "12px",
    },
    "& .edit-employee-success-modal .title-box h1": {
      margin: "0 0 10px",
      textAlign: "center",
      color: "var(--color-text)",
      fontSize: "34px",
    },
    "& .edit-employee-success-modal .message-box p": {
      margin: "0 0 24px",
      textAlign: "center",
      color: "var(--color-text-light)",
      lineHeight: 1.7,
      fontSize: "18px",
    },
    "& .edit-employee-success-modal .call-to-action-button-box": {
      display: "flex",
      justifyContent: "center",
    },
    "& .edit-employee-success-modal .call-to-action-button-box button": {
      backgroundColor: "var(--color-primary) !important",
      background: "var(--color-primary) !important",
      color: "var(--color-background) !important",
      width: "fit-content",
      minWidth: "140px",
      padding: "0.75rem 1rem",
      borderRadius: ".5rem",
      boxShadow: "0 14px 28px rgba(78, 87, 187, 0.2)",
      border: "none !important",
    },
    "& .edit-employee-success-modal .call-to-action-button-box button span": {
      color: "#FFFFFF !important",
    },
    "@media screen and (max-width: 425px)": {
      "& .employeeForm": {
        padding: "0",
      },
    },
    "@media screen and (min-width: 425px)": {
      "& .switch-column": {
        gap: "calc(var(--flexGap))",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },
    "@media screen and (min-width: 768px)": {
      "& .submit-column": {
        flexDirection: "row",
        justifyContent: "space-between",
      },
      "& .employeeForm": {
        padding: "var(--cardPadding)",
      },
    },
    "@media screen and (min-width: 1280px)": {
      "& .employeeForm button": {
        marginTop: "calc(var(--sectionMargin))",
      },
    },
  };
});

export const AddNewEmployeeRow = styled(Row)(() => {
  return {
    justifyContent: "space-between",
    "@media screen and (max-width: 1280px)": {
      gap: "calc(var(--flexGap)*1.5)",
      flexDirection: "column",
    },
  };
});
